import './scss/index.scss';

import Snackbar from './components/Snackbar';
/**
 * asyncComponent permite um code splitting na build
 * https://create-react-app.dev/docs/code-splitting/
 * Favorecendo menor carregamento de arquivos desnecessários
 */
import asyncComponent from './services/asyncComponent';
import MapView from './views/MapView';

import { SnackbarProvider } from 'notistack';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// async import
const AdmView = asyncComponent(() => import('./views/AdmView'));
const Factory = asyncComponent(() => import('./views/Factory'));
const FeedbackView = asyncComponent(() => import('./views/FeedbackView'));

export default () => {
  return (
    <Router>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        autoHideDuration = {5000}
        domRoot={document.getElementById('snackbars')}
        content={(key, { message, variant }) => {
          return <Snackbar id={key} message={message} variant={variant} />;
        }}
      >
        <Switch>
          <Route
            exact
            path="/adm/:view?/:subview?/:page?/:id?"
            component={AdmView}
          />
          <Route exact path="/factory/:name?" component={Factory} />
          <Route exact path="/:module?" component={MapView} />
          <Route exact path="/feedback/:page?" component={FeedbackView} />
        </Switch>
      </SnackbarProvider>
    </Router>
  );
};
